import { memo } from "react";

import type { TimelineItem } from "@/hooks/useChat";
import { UserCard } from "./cards/UserCard";
import { AgentCard } from "./cards/AgentCard";
import { CodeCard } from "./cards/CodeCard";
import { ConsoleCard } from "./cards/ConsoleCard";
import { SubagentCard } from "./cards/SubagentCard";
import { SystemCard } from "./cards/SystemCard";
import { DownloadCard } from "./cards/DownloadCard";
import { AuthRequestCard } from "./cards/AuthRequestCard";

interface ChatMessageCardProps {
  item: TimelineItem;
  sessionId?: string;
  onAuthComplete?: (sessionId: string, provider: string) => void;
}

export const ChatMessageCard = memo(function ChatMessageCard(
  props: ChatMessageCardProps,
) {
  switch (props.item.kind) {
    case "user":
      return <UserCard item={props.item} />;
    case "agent":
      return <AgentCard item={props.item} />;
    case "code":
      return <CodeCard item={props.item} />;
    case "console":
      return <ConsoleCard item={props.item} />;
    case "subagent":
      return <SubagentCard item={props.item} />;
    case "system":
      return <SystemCard item={props.item} />;
    case "download":
      return <DownloadCard item={props.item} />;
    case "auth_request":
      return (
        <AuthRequestCard
          item={props.item}
          sessionId={props.sessionId}
          onAuthComplete={props.onAuthComplete}
        />
      );
    default:
      return null;
  }
});
